<template>
  <div>
    <a-card class="m-height-full m-display-flex flex-column">
      <div slot="title">
        <span>{{ this.id ? 'Edit' : 'Create' }} Cooperative Deduction</span>
      </div>
      <template slot="extra">
      </template>
      <a-spin
        :spinning="loading.page"
        tip="Preparing To Show Data ...  "
      >
        <div class="container-essential">
          <a-form :form="form">
            <a-row :gutter="16">
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-item label="Periode">
                  <a-select
                    showSearch
                    v-decorator="['periode', { rules: [{ required: true }] }]"
                    :disabled="lock_header"
                  >
                    <a-select-option v-for="item in option.periode" :key="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="Description">
                  <a-input v-decorator="['description', { rules: [{ required: true }], initialValue: '' }]" :disabled="lock_header" autocomplete="false"/>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-item label="Upload Template Excel">
                  <a-upload
                    :fileList="fileList"
                    v-decorator="[
                      'file_upload',
                      { rules: [{ required: true,validator: doc_validation }]},
                    ]"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                  >
                    <a-button :disabled="lock_header">
                      <a-icon type="upload" />Select File
                    </a-button>
                  </a-upload>
                  <small>**If you dont have a file upload template, please click 
                    <a-button type="link" class="padding-remove" @click="handleDownloadTemplate">
                      <small>Download Template</small>
                    </a-button>
                  </small>
                </a-form-item>
              </a-col>
            </a-row>
            <a-divider class="margin-small"/>
            <a-row :gutter="16" type="flex" justify="end">
              <a-col>
                <a-button type="primary" class="margin-top" @click="handlePreview" :loading="loading.preview" :disabled="lock_header">
                  Preview
                </a-button>
                <a-button v-if="lock_header" type="danger" class="margin-left" @click="handleReset" :loading="loading.reset">
                  Reset
                </a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          class="ccd margin-top"
          :columns="columns"
          :rowKey="(record, index) => {return index;}"
          :dataSource="dataSource.data"
          :pagination="false"
          size="small"
          :scroll="{ x: 750, y: 400 }"
          bordered
          :rowClassName="(record) => {return Number(record.jumlah)==Number(record.jumlah_sebelum)?
            'r_same' : 'r_not_same'}"
        >
          <template slot="title">
            <a-row :gutter="16" type="flex" justify="space-between" align="middle">
              <a-col>
                <div class="ant-card-head-title" ><b>Deduction Detail</b></div>
              </a-col>
              <a-col>
                <a-input-search
                  v-model="search"
                  placeholder="Search Deduction Detail .. "
                />  
              </a-col>
            </a-row>
          </template>
          <template slot="no" slot-scope="text, data, index">
            {{ index + 1 }}
          </template>
          <template slot="simpanan_pokok" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.pokok"
            />
          </template>
          <template slot="simpanan_wajib" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.wajib"
            />
          </template>
          <template slot="biaya_pendaftaran" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.daftar"
            />
          </template>
          <template slot="jumlah_potongan" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.pinjaman"
            />
          </template>
          <template slot="deskripsi" slot-scope="item">
            {{ item.keterangan }}
          </template>
          <template slot="footer">
            <a-row :gutter="16" type="flex" justify="space-between" align="top">
              <a-col>
                <div><b><small>Color Desc:</small></b></div>
                <div style="display:flex;vertical-align: middle;margin-top:5px"><div class="r_same" style="width:20px;height: 100%;">&nbsp;</div><small>&nbsp;The installment/deduction amount is the same as the previous month's period</small></div>
                <div style="display:flex;vertical-align: middle;margin-top:5px"><div class="r_not_same" style="width:20px;height: 100%;">&nbsp;</div><small>&nbsp;Have a different installment/deduction amount than the previous period</small></div>
              </a-col>
              <a-col style="text-align: right;">
                <a-statistic title="Total Deduction Value (IDR)" :value="total_deduction" />
                <a-button type="primary" icon="save" class="margin-top" @click="handleSubmit" :loading="loading.submit" :disabled="!lock_header">Submit</a-button>
              </a-col>
            </a-row>
          </template>
        </a-table>
      </a-spin>
    </a-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "cooperative-deduction-create",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  props: ["id"],
  data(){
    let doc_validation = (rule, value, callback) => {
      if (this.fileList.length==0) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      fileList: [],
      loading: {
        preview: false,
        submit: false,
        page: false,
        reset: false
      },
      option: {
        periode : []
      },
      dataSource: {
        data: [],
        dataOriginal: [],
        dataEditOriginal: []
      },
      search: "",
      total_deduction: 0,
      lock_header: false
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted(){
    this.generateOption()
    if(this.id){
      this.fetchEditData()
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
    ]),
    columns(){
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: "60px",
          align: "right",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          width: "100px",
          align: "center",
        },
        {
          title: "Principal Saving",
          key: "simpanan_pokok",
          width: "170px",
          scopedSlots: { customRender: "simpanan_pokok" },
        },
        {
          title: "Mandatory Saving",
          key: "simpanan_wajib",
          width: "170px",
          scopedSlots: { customRender: "simpanan_wajib" },
        },
        {
          title: "Registration Fee",
          key: "biaya_pendaftaran",
          width: "170px",
          scopedSlots: { customRender: "biaya_pendaftaran" },
        },
        {
          title: "Levy Amount",
          key: "jumlah_potongan",
          width: "170px",
          scopedSlots: { customRender: "jumlah_potongan" },
        },
        {
          title: "Description",
          key: "deskripsi",
          scopedSlots: { customRender: "deskripsi" },
        },
      ]
        return kolom
    }
  },
  methods:{
    handleRemove() {
      if(!this.lock_header)
        this.fileList = [];
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    onSearch(){

    },
    handleDownloadTemplate(){
      this.asyncAxiosGet("potongan_koperasi/template",
        this.getAuth,
        {}
      )
      .then((response) => {
        window.open(this.$serviceUrl + response.url, "_blank");
      })
      .catch((err) => {
        console.log(err);
        this.displayMessage("error-emptyDocTemplate");
      });
    },
    handlePreview(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }
        
        let data = new FormData();
        if(this.id)
          data.append("id_potongan", this.id);
        data.append("periode", values.periode);
        data.append("description", values.description);
        data.append("file_upload", this.fileList[0]);

        this.loading.preview = true
        this.asyncAxiosPost(
          "potongan_koperasi/preview",
          "formdata",
          this.getAuth,
          data
        )
        .then((response) => {
          this.dataSource.data = response.dtl
          this.dataSource.dataOriginal = this.dataSource.data

          this.total_deduction = response.total
          this.lock_header = true
          this.loading.preview = false
        })
        .catch(() => {
          this.loading.preview = false
        });
      })
    },
    generateOption(){
      let thn = [moment().format('YYYY'), moment().subtract(1, 'year').format('YYYY')]
      for (let index = 0; index < thn.length; index++) {
        for (let index2 = 0; index2 < 12; index2++) {
          this.option.periode.push({
            value: moment().set('year', thn[index]).set('month', 11-index2).format('YYYY-MM'),
            label: moment().set('year', thn[index]).set('month', 11-index2).format('MMMM YYYY')
          })
        }
      }
      
    },
    handleSubmit(){
      const that = this;
      let title = "";
      title = "Are you sure to Submit this data?";
      that.$confirm({
        title: title,
        content: "Yes / No?",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.form.validateFields((err, values) => {
            if (err) {
              that.displayMessage("choose-action");
              return;
            }
            
            let data = new FormData();
            if(that.id)
              data.append("id_potongan", that.id);
            data.append("periode", values.periode);
            data.append("description", values.description);
            data.append("file_upload", that.fileList[0]);

            that.loading.submit = true
            that.asyncAxiosPost(
              "potongan_koperasi",
              "formdata",
              that.getAuth,
              data
            )
            .then(() => {
              that.displayMessage("success-save")
              that.$router.push({ name: "CooperativeList" });
            })
            .catch(() => {
              that.loading.submit = false
            });
          })
        },
        onCancel() {},
      })
    },
    async handleReset(){
      this.loading.reset = true
      if(this.id){
        this.dataSource.data = this.dataSource.dataEditOriginal.dtl
        this.dataSource.dataOriginal = this.dataSource.dataEditOriginal.dtl

        await this.convertfiles(this.dataSource.dataEditOriginal.header.lampiran, 
          this.dataSource.dataEditOriginal.header.lampiran_path, 
          this.dataSource.dataEditOriginal.header.lampiran_file)
        this.$nextTick(function () {
          this.form.setFieldsValue({
            periode: this.dataSource.dataEditOriginal.header.periode,
            description: this.dataSource.dataEditOriginal.header.description,
            // file_upload: this.fileList[0],
          });
        })
        this.total_deduction = this.dataSource.dataEditOriginal.header.total
        this.lock_header = false
      }else{
        this.dataSource.data = []
        this.dataSource.dataOriginal = [] 
        this.fileList = []
        this.total_deduction = 0
        this.lock_header = false
      }
      this.loading.reset = false
    },
    fetchEditData(){
      this.loading.page = true
      this.asyncAxiosGet("potongan_koperasi",
        this.getAuth,
        {id_potongan: this.id}
      )
      .then(async (response) => {
        this.dataSource.dataEditOriginal = response
        this.dataSource.data = response.dtl
        this.dataSource.dataOriginal = this.dataSource.data

        await this.convertfiles(response.header.lampiran, response.header.lampiran_path, response.header.lampiran_file)
        this.$nextTick(function () {
          this.form.setFieldsValue({
            periode: response.header.periode,
            description: response.header.description,
            // file_upload: this.fileList[0],
          });
        });
        
        this.total_deduction = Number(response.header.total)
        this.lock_header = false
        this.loading.page = false
      })
      .catch((err) => {
        console.log(err);
      });
    },
    convertfiles(file_name, url, file64) {
      let typefile = file_name.substr(file_name.lastIndexOf("."));

      if (typefile == ".xls") {
        typefile = "data:application/vnd.ms-excel;base64,";
      } else if (typefile == ".xlsx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      } else if (typefile == ".doc") {
        typefile = "data:application/msword;base64,";
      } else if (typefile == ".docx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
      } else if (typefile == ".pdf") {
        typefile = "data:application/pdf;base64,";
      } else if (typefile == ".jpeg" || typefile == ".jpg") {
        typefile = "data:image/jpeg;base64,";
      } else if (typefile == ".png") {
        typefile = "data:image/png;base64,";
      }

      var file = this.dataURLtoFile(
        typefile + file64,
        file_name
      );
      file.uid = "vc-upload-1-1";
      file.status = "done";
      file.exist = true;
      file.url = this.$serviceUrl + url;
      this.fileList = [file];
    }
  },
  watch:{
    "search"(val){
      if(val){ 
        this.dataSource.data = this.dataSource.dataOriginal.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
      }else{
        this.dataSource.data = this.dataSource.dataOriginal
      }
    }
  }

}
</script>
<style lang="less" scoped>
.ccd:deep{
  .ant-table-body{
    thead {
      th {
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="less">
  .r_same { 
    background-color: fade(@color-secondary, 35%)!important;
  }

  .r_not_same { 
    background-color: fade(@color-primary, 35%)!important;
  }
</style>